import { isEmpty } from "lodash";

/**
 * Checks if the booking is disabled
 * @param {Object} formik - formik object
 * @param {boolean} isDuplicate - is the booking a duplicate
 * @param {Array} pendingReservations - array of pending reservations
 * @param {boolean} disabledSelection - is the selection disabled
 * @param {boolean} isConflict - is there a conflict with recurring booking
 * @returns {boolean} is the booking disabled
 */
export const isAddBookingDisabled = (formik, isDuplicate, pendingReservations, disabledSelection, isConflict) => {
  const hasErrors = !isEmpty(formik.errors) || isConflict;
  const reservations = isDuplicate
    ? pendingReservations.filter(reservation => !reservation.bookingId)
    : pendingReservations;
  return hasErrors || disabledSelection || reservations.length === 0;
};

/**
 * Checks if saving an edited booking is disabled
 * @param {Object} formik - formik object
 * @param {boolean} disabledSelection - is the selection disabled
 * @param {Array} pendingReservations - array of pending reservations
 * @param {Function} compareValues - function to compare current values with original
 * @returns {boolean} is saving the booking disabled
 */
export const isSaveBookingDisabled = (formik, disabledSelection, pendingReservations, compareValues) => {
  const hasErrors = !isEmpty(formik.errors);
  const hasNoReservations = pendingReservations.length === 0;
  const hasNoChanges = compareValues(formik);
  return hasErrors || disabledSelection || hasNoReservations || hasNoChanges;
};
